// * LIVE
import content from '@/content/projects'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js